/* eslint-disable react/no-array-index-key */
/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable import/no-unresolved */
import { escapeRegExp } from "lodash";
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { memo } from "react";

interface HightlightedProps {
  text: string;
}

function Highlighted({ text = "" }: HightlightedProps) {
  const searchQuery = useAppSelector((state) => state.dashboard?.searchQuery);
  if (!searchQuery.trim()) {
    return <span>{text}</span>;
  }
  const regex = new RegExp(`(${escapeRegExp(searchQuery)})`, "gi");
  const parts = text.split(regex);
  return (
    <span>
      {parts
        .filter((part) => part)
        .map((part, i: number) =>
          regex.test(part) ? (
            <mark key={i} className="bg-orange-300">
              {part}
            </mark>
          ) : (
            <span key={i}>{part}</span>
          )
        )}
    </span>
  );
}

export default memo(Highlighted);
